import React from 'react';
import '../Steps.scss';
import { StepHeader } from './Header';
import { StepControls } from './Controls';
import { StepProps } from '../Steps';
import fourthStepImage from './TourImages/fourthStep.jpg';

export const FourthStep = (props: StepProps) => {
  return (
    <div className="step-container fourth-step">
      <StepHeader {...props} />
      <div className="step-container__title">
        Easily add more Websites or Facebook Pages and switch between connected
        accounts:
      </div>
      <div className="step-container__description-image-container">
        <img
          className="step-container__description-image"
          src={fourthStepImage}
        />
      </div>
      <StepControls {...props} />
    </div>
  );
};
